import React from "react";
import { useFormContext } from "react-hook-form";

import { Button } from "components";
import { FormTitle, LineDivider } from "components/layout";

import { SecondarySplitInformationFields } from "../secondarySplitInformationFields";
import { WaterfallCalculationMessage } from "../waterfallCalculationMessage";

import styles from "../../splitProfile.module.scss";

type WaterfallSecondarySplitInformationProps = {
	name: string;
	title: string;
	index: number;
	isLoading: boolean;
	splitInfo: { [key: string]: any };
	onRemoveSplitInfo: Function;
	setToggleAgentSelect: Function;
	toggleAgentSelect: boolean;
	isLastItem: boolean;
	isEditing: boolean;
};

export const WaterfallSecondarySplitInformation = ({
	name,
	title,
	index,
	isLoading = false,
	splitInfo,
	onRemoveSplitInfo,
	setToggleAgentSelect,
	toggleAgentSelect,
	isLastItem,
}: WaterfallSecondarySplitInformationProps) => {
	const { watch, getValues } = useFormContext();
	const secondarySplitInformation = watch("secondarySplitInformation");

	const residualsAmountBeforeSplitValue = getValues(
		`${name}.calculation.residualsAmountBeforeSplit`,
	);

	// left margin for alerts (starts from primary => +1)
	let marginShift = 30 * (index + 1);
	return (
		<div
			className={`${styles.sectionHolder}  ${
				isLastItem && styles.lastItem
			}`}
		>
			<LineDivider className="m-0" />
			<FormTitle>
				<h3>
					{title}
					<Button
						value="Remove Secondary Split Information"
						onClick={() => onRemoveSplitInfo?.(index)}
						variant="secondary"
						className={styles.removeBtn}
						disabled={
							index === 0 && secondarySplitInformation.length <= 1
						}
					/>
				</h3>
			</FormTitle>
			<div className={styles.alertHolder}>
				<WaterfallCalculationMessage
					value={residualsAmountBeforeSplitValue}
					inlineStyles={{ marginLeft: marginShift }}
				/>
			</div>
			<SecondarySplitInformationFields
				name={name}
				splitInfo={splitInfo}
				isLoading={isLoading}
				setToggleAgentSelect={setToggleAgentSelect}
				toggleAgentSelect={toggleAgentSelect}
				isWaterfall={true}
			/>
		</div>
	);
};
